import { render, staticRenderFns } from "./onboarding-selection-tile.vue?vue&type=template&id=aab71a8c&scoped=true"
import script from "./onboarding-selection-tile.vue?vue&type=script&lang=js"
export * from "./onboarding-selection-tile.vue?vue&type=script&lang=js"
import style0 from "./onboarding-selection-tile.vue?vue&type=style&index=0&id=aab71a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab71a8c",
  null
  
)

export default component.exports